// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#hidder {
	display: block;
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: white;
	z-index: 99988;
	opacity: 0.35;
}
#spinner.active {
	display: block;
}
#spinner {
	display: block;
	position: fixed;
	height: 90px;
	width: 90px;
	top: 50%;
	left: 50%;
	margin-left: -45px;
	z-index: 99989;

	/* border: 1px solid black; */
}
.rectangle {
	position: absolute;
	display: block;
	background-color: blue;
	width: 12px;
	height: 45px;
	border-radius: 6px;
}
.orange {
	background-color: #f26423;
}
.blue {
	background-color: #36496c;
}
.light-blue {
	background-color: #90bcd0;
}
.gray {
	background-color: #818181;
}
#orange-1 {
	bottom: 46px;
	left: 27px;
	transform-origin: bottom right;
	transform: rotate(-45deg);
	animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 0s infinite normal;
}
#orange-2 {
	top: 45px;
	left: 27px;
	transform-origin: top right;
	transform: rotate(45deg);
	animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 2.2s infinite normal;
}
#blue-1 {
	bottom: 59px;
	left: 41px;
	transform-origin: bottom right;
	transform: rotate(-45deg);
	animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 0.3s infinite normal;
}
#blue-2 {
	bottom: 59px;
	left: 36px;
	transform-origin: bottom left;
	transform: rotate(45deg);
	animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 0.8s infinite normal;
}
#light-blue-1 {
	top: 59px;
	left: 41px;
	transform-origin: top right;
	transform: rotate(45deg);
	animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 2s infinite normal;
}
#light-blue-2 {
	top: 59px;
	left: 36px;
	transform-origin: top left;
	transform: rotate(-45deg);
	animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 1.7s infinite normal;
}
#gray-1 {
	bottom: 46px;
	left: 51px;
	transform-origin: bottom left;
	transform: rotate(45deg);
	animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 1.1s infinite normal;
}
#gray-2 {
	top: 45px;
	left: 51px;
	transform-origin: top left;
	transform: rotate(-45deg);
	animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 1.5s infinite normal;
}

@keyframes height {
	0% {
		height: 45px;
	}
	50% {
		height: 45px;
	}
	70% {
		height: 25px;
	}
	80% {
		height: 25px;
	}
	100% {
		height: 45px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/shared/LoadingSpinner/LoadingSpinner.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,eAAe;CACf,WAAW;CACX,YAAY;CACZ,MAAM;CACN,OAAO;CACP,iBAAiB;CACjB,cAAc;CACd,aAAa;AACd;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,eAAe;CACf,YAAY;CACZ,WAAW;CACX,QAAQ;CACR,SAAS;CACT,kBAAkB;CAClB,cAAc;;CAEd,6BAA6B;AAC9B;AACA;CACC,kBAAkB;CAClB,cAAc;CACd,sBAAsB;CACtB,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,YAAY;CACZ,UAAU;CACV,8BAA8B;CAC9B,yBAAyB;CAEzB,0EAA0E;AAC3E;AACA;CACC,SAAS;CACT,UAAU;CACV,2BAA2B;CAC3B,wBAAwB;CAExB,4EAA4E;AAC7E;AACA;CACC,YAAY;CACZ,UAAU;CACV,8BAA8B;CAC9B,yBAAyB;CAEzB,4EAA4E;AAC7E;AACA;CACC,YAAY;CACZ,UAAU;CACV,6BAA6B;CAC7B,wBAAwB;CAExB,4EAA4E;AAC7E;AACA;CACC,SAAS;CACT,UAAU;CACV,2BAA2B;CAC3B,wBAAwB;CAExB,0EAA0E;AAC3E;AACA;CACC,SAAS;CACT,UAAU;CACV,0BAA0B;CAC1B,yBAAyB;CACzB,4EAA4E;AAC7E;AACA;CACC,YAAY;CACZ,UAAU;CACV,6BAA6B;CAC7B,wBAAwB;CAExB,4EAA4E;AAC7E;AACA;CACC,SAAS;CACT,UAAU;CACV,0BAA0B;CAC1B,yBAAyB;CAEzB,4EAA4E;AAC7E;;AAoBA;CACC;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;AACD","sourcesContent":["#hidder {\n\tdisplay: block;\n\tposition: fixed;\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tbackground: white;\n\tz-index: 99988;\n\topacity: 0.35;\n}\n#spinner.active {\n\tdisplay: block;\n}\n#spinner {\n\tdisplay: block;\n\tposition: fixed;\n\theight: 90px;\n\twidth: 90px;\n\ttop: 50%;\n\tleft: 50%;\n\tmargin-left: -45px;\n\tz-index: 99989;\n\n\t/* border: 1px solid black; */\n}\n.rectangle {\n\tposition: absolute;\n\tdisplay: block;\n\tbackground-color: blue;\n\twidth: 12px;\n\theight: 45px;\n\tborder-radius: 6px;\n}\n.orange {\n\tbackground-color: #f26423;\n}\n.blue {\n\tbackground-color: #36496c;\n}\n.light-blue {\n\tbackground-color: #90bcd0;\n}\n.gray {\n\tbackground-color: #818181;\n}\n#orange-1 {\n\tbottom: 46px;\n\tleft: 27px;\n\ttransform-origin: bottom right;\n\ttransform: rotate(-45deg);\n\t-webkit-animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 0s infinite normal;\n\tanimation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 0s infinite normal;\n}\n#orange-2 {\n\ttop: 45px;\n\tleft: 27px;\n\ttransform-origin: top right;\n\ttransform: rotate(45deg);\n\t-webkit-animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 2.2s infinite normal;\n\tanimation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 2.2s infinite normal;\n}\n#blue-1 {\n\tbottom: 59px;\n\tleft: 41px;\n\ttransform-origin: bottom right;\n\ttransform: rotate(-45deg);\n\t-webkit-animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 0.3s infinite normal;\n\tanimation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 0.3s infinite normal;\n}\n#blue-2 {\n\tbottom: 59px;\n\tleft: 36px;\n\ttransform-origin: bottom left;\n\ttransform: rotate(45deg);\n\t-webkit-animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 0.8s infinite normal;\n\tanimation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 0.8s infinite normal;\n}\n#light-blue-1 {\n\ttop: 59px;\n\tleft: 41px;\n\ttransform-origin: top right;\n\ttransform: rotate(45deg);\n\t-webkit-animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 2s infinite normal;\n\tanimation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 2s infinite normal;\n}\n#light-blue-2 {\n\ttop: 59px;\n\tleft: 36px;\n\ttransform-origin: top left;\n\ttransform: rotate(-45deg);\n\tanimation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 1.7s infinite normal;\n}\n#gray-1 {\n\tbottom: 46px;\n\tleft: 51px;\n\ttransform-origin: bottom left;\n\ttransform: rotate(45deg);\n\t-webkit-animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 1.1s infinite normal;\n\tanimation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 1.1s infinite normal;\n}\n#gray-2 {\n\ttop: 45px;\n\tleft: 51px;\n\ttransform-origin: top left;\n\ttransform: rotate(-45deg);\n\t-webkit-animation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 1.5s infinite normal;\n\tanimation: height 2.5s cubic-bezier(0.9, 0.5, 0.5, 0.9) 1.5s infinite normal;\n}\n\n@-webkit-keyframes height {\n\t0% {\n\t\theight: 45px;\n\t}\n\t50% {\n\t\theight: 45px;\n\t}\n\t70% {\n\t\theight: 25px;\n\t}\n\t80% {\n\t\theight: 25px;\n\t}\n\t100% {\n\t\theight: 45px;\n\t}\n}\n\n@keyframes height {\n\t0% {\n\t\theight: 45px;\n\t}\n\t50% {\n\t\theight: 45px;\n\t}\n\t70% {\n\t\theight: 25px;\n\t}\n\t80% {\n\t\theight: 25px;\n\t}\n\t100% {\n\t\theight: 45px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
